import { CONTACT_ADDRESS_MESSAGES, ContactAddressMessages } from "./address-section.messages";
import {
  CONTACT_REGISTRATION_INFO_MESSAGES,
  ContactRegistrationInfoMessages,
} from "./contact-registration-info.messages";
import {
  CONTACT_DOCUMENT_TYPE_MESSAGES,
  ContactDocumentTypeMessages,
} from "./contact-document-type.messages";
import {
  CONTACT_PERSON_TYPE_MESSAGES,
  ContactPersonTypeMessages,
} from "./contact-person-type.messages";
import { CONTACT_REQUEST_MESSAGES, ContactRequestMessages } from "./contact-request-messages";
import { CONTACT_PHONE_MESSAGES, ContactPhoneSectionMessages } from "./phone-section.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { GENDER_MESSAGES, GenderMessages } from "../gender/gender.messages";

export type ContactInfoMessages = ContactRequestMessages &
  ContactPersonTypeMessages &
  ContactPhoneSectionMessages &
  ContactDocumentTypeMessages &
  GenderMessages &
  ActionButtonMessages &
  ContactAddressMessages &
  ContactRegistrationInfoMessages & {
    // FORM YUP ERRORS
    errorRequiredPersonType: string;
    errorRequiredFirstName: string;
    errorRequiredLastName: string;
    errorRequiredEmail: string;
    errorRequiredGender: string;
    errorRequiredDocument: string;
    errorInvalidEmail: string;
    errorRequiredDocumentType: string;
    invalidCPF: string;
    invalidRG: string;
    invalidCNPJ: string;

    // INPUT LABELS
    firstNameLabel: string;
    lastNameLabel: string;
    nickNameLabel: string;
    emailLabel: string;
    persontypeLabel: string;
    genderLabel: string;
    birthDateLabel: string;
    documentTypeLabel: string;
    documentLabel: string;

    // TAG SECTION
    addTagLabel: string;
    addButtonLabel: string;
    tagsTitle: string;
    tagExistsError: string;

    // TITLES
    contactInformationTitle: string;
    tagsSectionTitle: string;

    // ADDRESSES
    noAdditionalAddressesMessage: string;
  };

export const CONTACT_INFO_MESSAGES: ContactInfoMessages = {
  ...CONTACT_REQUEST_MESSAGES,

  // FORM YUP ERRORS
  errorRequiredPersonType: "O tipo de pessoa é obrigatório!",
  errorRequiredDocumentType: "O tipo de documento é obrigatório!",
  errorRequiredFirstName: "O nome do contato é obrigatório!",
  errorRequiredLastName: "O sobrenome do contato é obrigatório!",
  errorRequiredEmail: "O email do contato é obrigatório!",
  errorRequiredGender: "O gênero do contato é obrigatório!",
  errorRequiredDocument: "O documento do contato é obrigatório!",
  errorInvalidEmail: "Digite um email válido",
  invalidCPF: "Digite um CPF válido",
  invalidRG: "Digite um RG válido",
  invalidCNPJ: "Digite um CNPJ válido",

  // INPUT LABELS
  firstNameLabel: "Nome",
  lastNameLabel: "Sobrenome",
  nickNameLabel: "Apelido",
  emailLabel: "Email",
  genderLabel: "Gênero",
  birthDateLabel: "Data de Nascimento",
  documentLabel: "CPF/CNPJ",
  persontypeLabel: "Tipo de Pessoa",
  documentTypeLabel: "Tipo de Documento",

  // TAG SECTION
  addTagLabel: "Adicione uma ou mais tags",
  addButtonLabel: "Adicionar",
  tagsTitle: "TAGS",
  tagExistsError: "Essa tag já existe para este contato",

  // TITLES
  contactInformationTitle: "Informações do contato",
  tagsSectionTitle: "Tag's",

  // ADDRESSES
  noAdditionalAddressesMessage: "Nenhum endereço adicional foi adicionado a este contato.",

  ...GENDER_MESSAGES,
  ...CONTACT_PHONE_MESSAGES,
  ...CONTACT_PERSON_TYPE_MESSAGES,
  ...CONTACT_DOCUMENT_TYPE_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...CONTACT_ADDRESS_MESSAGES,
  ...CONTACT_REGISTRATION_INFO_MESSAGES,
};
